import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Cashew.css";

export default function Cashew() {
    const cashewProducts = [
        {
            id: 1,
            name: "W180 CASHEW",
            image: "/assets/img/CashewNuts/W180-King-of-Cashews.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Premium snack packs",
                        "Luxury confectionery",
                        "Bakery products",
                        "Gift packaging",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Large kernel size",
                        "Premium quality grade",
                        "Rich creamy taste",
                        "High market demand",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "W210 CASHEW",
            image: "/assets/img/CashewNuts/W210.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Snack food industry",
                        "Bakery applications",
                        "Confectionery products",
                        "Food processing",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Uniform appearance",
                        "Excellent flavor",
                        "Premium export quality",
                        "Good nutritional value",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "W240 CASHEW",
            image: "/assets/img/CashewNuts/W240.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Roasted cashew products",
                        "Nut mixes",
                        "Desserts and sweets",
                        "Retail packaging",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Popular commercial grade",
                        "Balanced size and cost",
                        "High consumer acceptance",
                        "Rich nutritional profile",
                    ],
                },
            ],
        },

        {
            id: 4,
            name: "W320 CASHEW",
            image: "/assets/img/CashewNuts/W320.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Food manufacturing",
                        "Snack processing",
                        "Bakery industry",
                        "Confectionery production",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Most demanded grade",
                        "Cost-effective option",
                        "Good taste and texture",
                        "Widely available",
                    ],
                },
            ],
        },

        {
            id: 5,
            name: "W450 CASHEW",
            image: "/assets/img/CashewNuts/W450.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bulk food processing",
                        "Bakery fillings",
                        "Cashew powder production",
                        "Industrial food applications",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Economical grade",
                        "Suitable for processing",
                        "Consistent quality",
                        "Versatile usage",
                    ],
                },
            ],
        },

        {
            id: 6,
            name: "CASHEW PIECES",
            image: "/assets/img/CashewNuts/Cashew-Pieces.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Cookies and biscuits",
                        "Chocolate manufacturing",
                        "Ice cream toppings",
                        "Food processing industries",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Cost-effective ingredient",
                        "Easy to process",
                        "Maintains cashew flavor",
                        "Suitable for bulk production",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Cashew Nut (Kaju)"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Cashew Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality Cashew Nut (Kaju) products sourced from
                        trusted suppliers worldwide.
                    </p>

                    <div className="pp-grid">
                        {cashewProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}